module.exports = __webpack_public_path__ + "images/arrow-right-666.png";